import "./index.scss";
import { GeneralSmallArrowRight } from "@wise-emotions/react-icons";
import { ImageProps } from "components/Image/types";
import { InspectorModeTags } from "@contentful/live-preview/dist/inspectorMode/types";
import IconWrap from "components/Icon/IconWrap";
import Image from "components/Image";
import React from "react";
import classNames from "classnames";
import parse from "html-react-parser";

export type Card07Props = {
  text: string;
  titleProps: string;
  imageProps: ImageProps;
  cta: string;
  liveInspector: Record<string, InspectorModeTags>;
  hasParentLink: boolean;
  headingLabelInfo?: string;
  headingLabelType?: string;
};

const Card07 = ({
  text,
  hasParentLink = true,
  headingLabelType,
  headingLabelInfo,
  imageProps,
  cta,
  titleProps,
  liveInspector,
}: Card07Props) => {
  const cardCls = classNames("Card07", "box-shadow-card", {
    "Card07--has-parent-link box-shadow-card--hasHover": hasParentLink,
  });
  // hasLabelType
  const labelTypePresent = !!headingLabelType;
  // hasLabelInfo
  const labelInfoPresent = !!headingLabelInfo;
  const headingIsPresent = labelInfoPresent || labelTypePresent;
  const labelTypeCls = classNames("Card07__heading-type");
  const labelInfoCls = classNames("Card07__heading-info");

  return (
    <div className={cardCls} {...liveInspector?.card}>
      <div className="Card07__image-container">
        <div data-testid="image" className="Card07__image-background">
          <Image {...imageProps} />
          {/* <div className="Card07__image-gradient" /> */}
        </div>
      </div>
      <div className="Card07__wrapper">
        {headingIsPresent && (
          <div className="Card07__heading-wrapper">
            {labelTypePresent && (
              <div className={labelTypeCls}>{headingLabelType}</div>
            )}
            {labelInfoPresent && (
              <div className={labelInfoCls}>{headingLabelInfo}</div>
            )}
          </div>
        )}
        <div className="Card07__title">{parse(titleProps)}</div>
        <div className="Card07__text">{parse(text)}</div>
      </div>
      <div className="Card07__cta">
        <span>{cta}</span>
        <IconWrap>
          <GeneralSmallArrowRight />
        </IconWrap>
      </div>
    </div>
  );
};

export default Card07;
